module.exports = __webpack_public_path__ + "h5/img/xiaoli.8ab2ab61.png";